import React, { useState } from 'react'
import backArrow from "./assets/back-arrow.svg"


function TermsAndConditionsModal(props) {
  
  return (
    <div className="modal-container">
        <div className="custom-header">
            <img src={backArrow} onClick={props.toggle} alt="" />
            <p>Terms and conditions</p>
        </div>
        <div className="content">       
          <h3>
            Terms and Conditions for Using Paymob Platforms
          </h3>   
          
          <p className="bold">
            Please read the following terms and conditions carefully before agreeing.
          </p>
          
          <p>
            This agreement governs and regulates your commercial relationship with us. By clicking on the “Pay” button below then you agree to the following terms that will bind you, but if you do not agree to the following terms, refrain from clicking on the “Pay” button below.
          </p>
          
          <p className="bold">
            Who are we and what is purpose of this agreement?
          </p>
          
          <p>
            We are Accept Technology and Electronic Payment Services Company - Egyptian joint stock company registered in Cairo Investment Commercial Registry Office under No. 118369, and headquartered in 5 H Street 263 branching from Nasr Street - New Maadi - Cairo Governorate. We license you to use:
          </p>
          
          <ul>
            <li>
              Related online or electronic documents (<strong>Documents</strong>).
            </li>
            <li>
              The service you connect to through your electronic devises using  our platforms (<strong>Platform</strong>)and the content we provide to you through it (the <strong>Service</strong>).
            </li>
          </ul>
          
          <p>
            - As permitted in these terms.
          </p>
          
          <p className="bold">
            How to tell us about problems
          </p>
          
          <p>
            - If you like to know more about the Service or have any problems during using it, please take a look at our support resources at www.paymob.com
          </p>
          
          <p>
            - If you believe that the Platform or Services are defective or misdescribed or want to contact us for any other reason, please email our Customer Service team at support@paymob.com or call them at 19079.
          </p>
          
          <p>
            - If we have to notify you of something or contact you, we will do so by email, SMS, by e-mail or speak to you directly through a recorded call using the contact details you have provided to us.
          </p>
          <p className="bold">
            How can you use the Platform
          </p>
          
          <p className="bold">
            1.	As Merchants/Business Owners:
          </p>
          
          <p>
            In exchange for your agreement to comply with these terms, you may:
          </p>
          
          <ul>
            <li>
              View and use the Platform and the Service on it for your business purposes only. 
            </li>
            <li>
              Use any documents to support your authorized use of the Platform and the Service.
            </li>
          </ul>
          
          
          <p className="bold">
            2.	As a Consumer: 
          </p>
          
          <p>
            In exchange for your agreement to comply with these terms, you may:
          </p>
          
          <ul>
            <li>
              Click pay through our Platform, to be updated with the newly discounts/promotions through the data provided by the consumer (e.g., messages, emails, etc.….)
            </li>
          </ul>
          <p className="bold">
            How do you register your data on the Platform
          </p>
          
          <p>
            - Start by clicking on the “pay” to access our gateway through using our platform.   
          </p>
          
          <p>
            - Create your profile and enter your personal data, including your mobile phone number, your bank account number that you want to deal with through the Platform, your National ID Number, your commercial registration number, tax card, and any data or documents that you are requested to upload electronically.
          </p>
          
          <p>
            - After we agree to the registration data, we will allow you to enjoy various electronic financial payment services through the Platform and send you any further promotions that our platform offers. 
          </p>
          
          <p>
            - You acknowledge and undertake that your registration on the Platform to obtain the services is for your account, and that you are the true and only beneficiary of your subscription to them. Further, you shall update your data as soon as any changes occur or whenever we ask you to do so.
          </p>
          
          <p>
            - For paying through our platform from any Merchant, Consumers need to access our gateway through using our platform and they will have complete access to our services. 
          </p>
          <p className="bold">
            The financial services provided by the Platform to you
          </p>
          
          <p>
            - You can view your transaction history of all incoming and outgoing payments made on payment media made through us. You can also set the time period you wish to review its transactions using the drop-down menu. The transaction details for the specified time period, including debits, credits, balance, description, and adjustments are shown. These records are final and binding on you if you do not object to the same within 10 days from date of the error.
          </p>
          
          <p>
            - You can know the details of incoming and outgoing transactions and the amounts owed to you or owed by you through the "Dafter" program.
          </p>
          
          <p>
            - You can accept payments due to you, related to your business, from your customers, suppliers or others through contactless technology on your mobile phone (Tap On Phone) by swiping debit cards, credit cards or prepaid cards on it, or through QR codes ( QR Code) that is generated through the Platform for each payment, and collect their value in your smart wallet, or through payment links that are created for you so that you can send them directly to your customers’ favorite devices to be ready to process their payments and collect them for your account.
          </p>
          
          <p>
            - You can pay through different payment methods depending on the Merchant you are purchasing from. 
          </p>
          
          <p>
            - You can be reassured about the safety of your provided data as our platform is granted the highest level of data protection as our platform is awarded the PCI License. 
          </p>
          <p className="bold">
            Payments made through the Platform
          </p>
          
          <p>
            - You are responsible for all transactions on or through your device. You undertake that all transactions are legitimate and used for legitimate purposes and for persons who are not prohibited from dealing with, and that the collected funds do not conflict with Anti-Money Laundering Law and its implementing regulations and decisions implementing it.
          </p>
          
          <p>
            - You are responsible for giving your clients receipts or invoices for the goods or services you provide to them, in accordance with the conditions established by law.
          </p>
          
          <p>
            - You shall not carry out electronic payments on behalf of others.
          </p>
          
          <p>
            - You shall maintain confidentiality of the data of your dealers. In all cases, you shall not store or even review the numbers of the cards used. If you violate this clause and it is proven that one of your clients was harmed due to your violation or violation of one of your affiliates, you shall bear full responsibility for the resulting damage.
          </p>
          
          <p>
            - Different payment methods available on the Platform are subject to minimum and maximum limits that we determine from time to time. To find out the applicable limits for each payment method, please click on the link <a href='www.insertthelimits.com' target="_blank">www.insertthelimits.com</a>. 
          </p>
          
          <p>
            - Expenses and commissions owed to us, which we review and amend from time to time, shall be added to each payment of. For fees and commissions, please click on the link <a href='www.insertfees.com' target="_blank">www.insertfees.com</a>. 
          </p>
          
          <p className="bold">
            Confidentiality 
          </p>
          
          <p>
            - We are responsible for maintaining confidentiality of your data, which will not be disclosed except at request of the supervisory authorities or as required by legal procedures or after your approval. However, you are responsible for protecting your data with username and password that allow you to enter the Platform.
          </p>
          
          
          
          <p className="bold">
            Assigning the Platform to another person
          </p>
          
          <p>
            - We give you right to use the Platform and the Service as described above, so you shall not otherwise assign the Platform or the Service to another person, whether for money or anything else or for free.
          </p>
          <p className="bold">
            Changes to these terms
          </p>
          
          <p>
            - We may need to change these terms to incorporate changes as required by law or best practices or to add additional features or services that we offer, in which case we will notify you of any change by sending an SMS with details of the change or notify you of the change next time when the Platform is operated.
          </p>
          <p className="bold">
            Platform update and service changes
          </p>
          
          <p>
            From time to time, we may automatically update the Platform and change the Service to improve performance, improve functions, introduce changes to the operating system, address security issues, or provide additional services. 
          </p>
          
          <p className="bold">
            Licensing restrictions
          </p>
          
          <p>
            - You agree to:
          </p>
          
          <ul>
            <li>
              Not rent, lease, sublicense, loan, make available or otherwise make available the Platform or the Services, in whole or in part, to any person without our prior written consent;
            </li>
            <li>
              Not copy the Platform, the Documentation or the Services, except as part of normal use of the Platform or when it is necessary for purpose of backup or operational security;
            </li>
            <li>
              Not translate, integrate, adapt, alter, change or modify all or part of the Platform, the Documentation or the Services and not allow the Platformor the Services or any part thereof to be incorporated into any other software, except as is necessary to use the Platformand the Services on the devices as permitted under these terms;
            </li>
          </ul>
          
          <p>
            - Comply with all applicable technology control export laws and regulations that apply to technology used or supported by the Platformor any Service.
          </p>
          <p className="bold">
            Warnings and limitations of use
          </p>
          <p>
            You shall not use the Platformor any Service in any unlawful manner, or for any unlawful purpose, or in any manner inconsistent with these terms, or in transactions for political purposes, whether internal or external, or act in a fraudulent or harmful manner, for example by hacking or inserting malicious code, such as viruses or harmful data into the Platform, any service or any operating system;
          </p>
          
          <p>
            - You shall not infringe our intellectual property rights or the rights of any third party in connection with your use of the Platformor any Service;
          </p>
          
          <p>
            - You shall not transmit any defamatory, offensive or otherwise objectionable material in connection with your use of the Platformor any Service.
          </p>
          
          <p>
            - You shall not use the Platformor any Service in such manner that may damage, disable, overburden or harm our systems or security, or interfere with other users; and 
          </p>
          
          <p>
            - You shall not collect any information or data from any Service or our systems or attempt to decrypt any transmissions to or from the servers running any Service.
          </p>
          
          <p>
            - It is prohibited to add any commissions or additional expenses to the declared prices for the merchant’s customers as a result of using payment through the Platformor using this Platformto pay off another card indebtedness, or in exchange for value of the transaction in cash.
          </p>
          
          <p>
            - It is also prohibited to use the program in trading in any of the following:
          </p>
          
          <ul>
            <li>
              Weapons of all kinds and forms, drugs and medicines, gambling, betting, lotteries, and products and materials that are immoral or indecent and which are criminalized by Egyptian law, trade in human organs and illegal health products, and expensive jewelry such as gold, silver and precious stones. It is prohibited to use counterfeit or stolen trademarks, to sell tobacco or smoking products outside Arab Republic of Egypt, or to illegally download software and computer materials as programs, movies, music, games, digital wallets, or to convert money electronically from one currency to another currency.
            </li>
          </ul>
          <p className="bold">
            Intellectual property rights
          </p>
          
          <p>
            - All intellectual property rights on the Platform, Documentation and Services worldwide are owned by us and the rights on the Platform and Services are licensed (not sold) to you. You have no intellectual property rights in or over the Platform, Documentation, or Services other than the right to use them in accordance with these terms.
          </p>
          <p className="bold">
            Our responsibility for losses or damages you incur
          </p>
          
          <p>
            - We will do our best to ensure that availability of the Platformis uninterrupted and that data transmissions will be error-free. However, due to nature of the Internet, this cannot be guaranteed. Also, your access to the Services may be suspended or sometimes restricted to allow for repairs, maintenance, or introduction of new facilities or services. We will attempt to determine frequency and duration of any such suspension or restriction.
          </p>
          
          <p>
            - We will not be liable for (i) losses not caused by any breach by us, (ii) any business loss (including missed profits, revenue, contracts, anticipated savings, data, goodwill, or wasted expenses), or (iii) any indirect or consequential losses that were not foreseeable by you and us when you started using the Platform.
          </p>
          
          <p>    
            - We will not be liable for any delay or failure to comply with our obligations under these terms if the delay or failure is caused by any cause beyond our reasonable control.
          </p>
          
          <p>
            - Merchant agrees and undertakes to bear any compensation claimed by him from Paymob in accordance with the law as result of any subsequent losses or missed profits (chargebacks - refunds) as result of using the Platform, and shall be liable for any claims made by any third party as result of his breach to any of provisions of these terms.
          </p>
          <p className="bold">
            Termination or suspension of service on the Platform
          </p>
          
          <p>
            - We may suspend or terminate your access to the Service at any time, without notice and without specifying any reason. Except for the matters that include risk to security, privacy or integrity of the Service, payments and data that we process, we will then attempt to give you prior notice of suspension or termination, but we are not obliged to do so.
          </p>
          
          <p>
            - Termination or suspension of the Service shall not affect your liability for transactions initiated through the Service using your password.
          </p>
          <p className="bold">
            Laws applicable to this contract and jurisdiction 
          </p>
          
          <p>
            - This agreement shall be subjected to laws of Arab Republic of Egypt. Cairo Economic Courts shall have jurisdiction to consider any dispute arising from implementation or change of any of the terms and conditions contained herein.
          </p>
        </div>
    </div>
  )
}

export default TermsAndConditionsModal